import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService {

  /**
   * Converts technical HTTP errors into user-friendly messages
   * @param error - The HTTP error response
   * @returns A user-friendly error message
   */
  getUserFriendlyErrorMessage(error: HttpErrorResponse): string {
    // Network error or backend is down (status 0)
    if (error.status === 0) {
      return 'Unable to connect to the server. Please check your internet connection and try again.';
    }

    // Server errors (5xx)
    if (error.status >= 500) {
      return 'The server is currently experiencing issues. Please try again later.';
    }

    // Authentication errors (401)
    if (error.status === 401) {
      return error.error?.message || 'Invalid email or password. Please try again.';
    }

    // Forbidden errors (403)
    if (error.status === 403) {
      return error.error?.message || 'You do not have permission to perform this action.';
    }

    // Not found errors (404)
    if (error.status === 404) {
      return error.error?.message || 'The requested resource was not found.';
    }

    // Client errors (4xx) - try to get message from backend
    if (error.status >= 400 && error.status < 500) {
      // sign in - invalid request
      if (error.error?.errors.detail) {
        return error.error?.errors.detail;
      }

      // sign up - invalid request
      console.log(error.error?.errors.email[0]);
      if (error.error?.errors.email['0']) {
        // capitalize the first letter of the error message
        return error.error?.errors.email['0'][0].toUpperCase() + error.error?.errors.email['0'].slice(1);
      }

      return error.error?.message || 'Invalid request. Please check your information and try again.';
    }

    // Fallback for any other error
    return error.error?.message || 'An unexpected error occurred. Please try again.';
  }

  /**
   * Extracts error message from various error formats
   * @param error - Error object (can be HttpErrorResponse, Error, or any)
   * @returns A user-friendly error message
   */
  extractErrorMessage(error: any): string {
    // If it's an HttpErrorResponse, use the main method
    if (error instanceof HttpErrorResponse) {
      return this.getUserFriendlyErrorMessage(error);
    }

    // If it has an error property that's an HttpErrorResponse
    if (error?.error instanceof HttpErrorResponse) {
      return this.getUserFriendlyErrorMessage(error.error);
    }

    // If it has a message property
    if (error?.message) {
      return error.message;
    }

    // If it's a string
    if (typeof error === 'string') {
      return error;
    }

    // Fallback
    return 'An unexpected error occurred. Please try again.';
  }
}
